import { Stack, styled } from '@mui/material';

import { colors } from '@/theme/variables';

export const FormTextEditorFieldRoot = styled(Stack)(({ theme }) => ({
  flex: 1,
  width: '100%',
  '& .rdw-editor-wrapper': {
    border: `1px solid ${colors.grey[10]}`,
    borderRadius: 2,
    // overflow: 'hidden',
  },
  '& .rdw-editor-toolbar': {
    borderTopWidth: 0,
    borderRightWidth: 0,
    borderLeftWidth: 0,
  },
  '& .rdw-editor-main': {
    wordBreak: 'normal',
    overflowWrap: 'break-word',
    lineBreak: 'auto',
    maxHeight: 'calc(100vh - 620px)',
    overflowY: 'auto',
    fontWeight: 'normal',
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
  },
  '& .rdw-editor-main .DraftEditor-root, & .rdw-editor-main .DraftEditor-editorContainer, & .rdw-editor-main .public-DraftEditor-content':
    {
      minHeight: 250,
    },
  '& .rdw-suggestion-dropdown': {
    width: '400px',
    maxHeight: 'fit-content',
  },
  // Fix alignment on wrapped text: Draft.js sets text-align:left on
  // .public-DraftStyleDefault-ltr which overrides the wrapper alignment.
  // Override it per alignment class with !important.
  '& .rdw-center-aligned-block .public-DraftStyleDefault-ltr': {
    textAlign: 'center !important',
  },
  '& .rdw-right-aligned-block .public-DraftStyleDefault-ltr': {
    textAlign: 'right !important',
  },
  '& .rdw-justify-aligned-block .public-DraftStyleDefault-ltr': {
    textAlign: 'justify !important',
  },
  // Library sets inner div to inline-block for aligned blocks, which
  // changes line-height. Reset to block to keep consistent spacing.
  '& .rdw-center-aligned-block > div, & .rdw-right-aligned-block > div, & .rdw-justify-aligned-block > div, & .rdw-left-aligned-block > div':
    {
      display: 'block',
    },
  ...(theme.palette.mode !== 'light' && {
    '.rdw-editor-toolbar': {
      background: '#1e1e1e !important',
      border: '1px solid #333 !important',
    },
    '.rdw-option-wrapper': {
      background: '#2a2a2a !important',
      border: '1px solid #444 !important',
      color: '#f0f0f0 !important',
      img: {
        filter: 'invert(1)',
      },
    },
    '.rdw-option-wrapper:hover': {
      background: '#3a3a3a !important',
      borderColor: '#555 !important',
    },
    '& .rdw-dropdown-wrapper': {
      backgroundColor: '#2a2a2a',
      border: '1px solid #444',
      color: '#f0f0f0',
    },

    // Dropdown options
    '& .rdw-dropdown-option': {
      backgroundColor: '#2a2a2a',
      color: '#f0f0f0',
      '&:hover': {
        backgroundColor: '#3a3a3a',
      },
    },

    // Selected option
    '& .rdw-dropdownoption-active': {
      backgroundColor: '#444',
      color: '#fff',
    },

    // Caret icon
    '& .rdw-dropdown-carettoclose': {
      borderTop: '6px solid #f0f0f0',
    },
  }),
}));
